const storePrefix = 'signin.'
export default {
  LOCAL_STATES: {
    SSI_ACCESS_TOKEN: `${storePrefix}ssiAccessToken`,
    KYC_ACCESS_TOKEN: `${storePrefix}cavachAccessToken`,
    REDIRECT_URL: `${storePrefix}redirectUrl`,
    AUTHORIZATION: `${storePrefix}authorization`,
    PROFILE: `${storePrefix}profile`,
    SUBDOMAIN: `${storePrefix}subdomain`,
    SESSIONS: `${storePrefix}session`,
    MOBILE_FLOW_SESSION: `${storePrefix}mobileFlowSession`,
    MOBILE_FLOW_STEP: `${storePrefix}mobileFlowStep`,
    PR: `${storePrefix}presentationRequest`,
    WIDGET_CONFIG: `${storePrefix}widgetConfigFromDb`,
    WIDGET_CONFIG_ID: `${storePrefix}widgetConfigId`,
    ON_CHAIN_CONFIG: `${storePrefix}onChainIssuerConfig`,
    KYC_SERVICE_USER_ACCESS_TOKEN: `${storePrefix}kycServiceUserAccessToken`,
    ENVIRONMENT: `${storePrefix}environment`,
    SESSION_EXPIRES_AT: `${storePrefix}sessionExpiresAt`,
    IS_NEW_USER: `${storePrefix}isNewUser`,
    UTM_SOURCE: `${storePrefix}utmSource`,
  },
}
